/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Distinguishes a full member from a household family member linked to a primary member.
 * @export
 */
export const WebApiModelsEnumerationTypesMemberType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesMemberType = typeof WebApiModelsEnumerationTypesMemberType[keyof typeof WebApiModelsEnumerationTypesMemberType];


export function WebApiModelsEnumerationTypesMemberTypeFromJSON(json: any): WebApiModelsEnumerationTypesMemberType {
    return WebApiModelsEnumerationTypesMemberTypeFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesMemberTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesMemberType {
    return json as WebApiModelsEnumerationTypesMemberType;
}

export function WebApiModelsEnumerationTypesMemberTypeToJSON(value?: WebApiModelsEnumerationTypesMemberType | null): any {
    return value as any;
}

